<div id="notes-bubble" [class.coordinator-app]="isCoordinatorApp">
    <button color="primary" id="notes-button" mat-raised-button type="button" (click)="openNotes()">
        <mat-icon>edit_note</mat-icon>
        <span class="notes-label">Notes</span>
        @if (noteCount() > 0) {
        <span class="notes-count">{{ displayCount() }}</span>
        }
    </button>
</div>